/* =========================
   PEGUU — ORDER STORE
   ESTADO GLOBAL DEL PEDIDO
========================= */

(() => {
  "use strict";

  /* =========================
     CONFIGURACIÓN
  ========================== */

  const ORDER_STORAGE_KEY =
    "peguu:sticker-order";

  const ORDER_UPDATED_EVENT =
    "peguu:order-updated";


  /* =========================
     UTILIDADES
  ========================== */

  const isPlainObject = (
    value
  ) =>
    Boolean(
      value &&
      typeof value ===
        "object" &&
      !Array.isArray(value)
    );


  const cloneValue = (
    value
  ) => {
    if (
      value === undefined
    ) {
      return undefined;
    }

    try {
      return JSON.parse(
        JSON.stringify(value)
      );

    } catch (error) {
      console.error(
        "No fue posible clonar el estado del pedido:",
        error
      );

      return null;
    }
  };


  const mergeObjects = (
    target,
    source
  ) => {
    const result = {
      ...(isPlainObject(target)
        ? target
        : {})
    };

    if (
      !isPlainObject(source)
    ) {
      return result;
    }

    Object.entries(
      source
    ).forEach(
      ([
        key,
        value
      ]) => {

        if (
          value === undefined
        ) {
          return;
        }

        if (
          isPlainObject(value)
        ) {
          result[key] =
            mergeObjects(
              result[key],
              value
            );

          return;
        }

        result[key] =
          cloneValue(value);
      }
    );

    return result;
  };


  /* =========================
     EVENTO DE ACTUALIZACIÓN
  ========================== */

  const dispatchUpdated = (
    order
  ) => {
    document.dispatchEvent(
      new CustomEvent(
        ORDER_UPDATED_EVENT,
        {
          detail: {
            order:
              cloneValue(order)
          }
        }
      )
    );
  };


  /* =========================
     LEER PEDIDO
  ========================== */

  const get = () => {
    try {
      const storedValue =
        sessionStorage.getItem(
          ORDER_STORAGE_KEY
        );

      if (
        !storedValue
      ) {
        return null;
      }

      const order =
        JSON.parse(
          storedValue
        );

      if (
        !isPlainObject(
          order
        )
      ) {
        return null;
      }

      return cloneValue(
        order
      );

    } catch (error) {
      console.error(
        "No fue posible recuperar el pedido:",
        error
      );

      return null;
    }
  };


  /* =========================
     GUARDAR PEDIDO COMPLETO
  ========================== */

  const set = (
    order
  ) => {
    if (
      !isPlainObject(
        order
      )
    ) {
      console.error(
        "El pedido debe ser un objeto válido."
      );

      return false;
    }

    try {
      const cleanOrder =
        cloneValue(
          order
        );

      sessionStorage.setItem(
        ORDER_STORAGE_KEY,
        JSON.stringify(
          cleanOrder
        )
      );

      dispatchUpdated(
        cleanOrder
      );

      return true;

    } catch (error) {
      console.error(
        "No fue posible guardar el pedido:",
        error
      );

      return false;
    }
  };


  /* =========================
     ACTUALIZAR PARCIALMENTE
  ========================== */

  const update = (
    partialOrder
  ) => {
    if (
      !isPlainObject(
        partialOrder
      )
    ) {
      console.error(
        "La actualización del pedido debe ser un objeto válido."
      );

      return false;
    }

    const currentOrder =
      get() || {};

    const updatedOrder =
      mergeObjects(
        currentOrder,
        partialOrder
      );

    return set(
      updatedOrder
    );
  };


  /* =========================
     ELIMINAR PROPIEDADES
  ========================== */

  const remove = (
    keys
  ) => {
    const order =
      get();

    if (
      !order
    ) {
      return false;
    }

    const keysToRemove =
      Array.isArray(keys)
        ? keys
        : [keys];

    keysToRemove.forEach(
      (key) => {
        if (
          typeof key !==
            "string" ||
          !key
        ) {
          return;
        }

        delete order[key];
      }
    );

    return set(
      order
    );
  };


  /* =========================
     LIMPIAR PEDIDO
  ========================== */

  const clear = () => {
    try {
      sessionStorage.removeItem(
        ORDER_STORAGE_KEY
      );

      dispatchUpdated(
        null
      );

      return true;

    } catch (error) {
      console.error(
        "No fue posible limpiar el pedido:",
        error
      );

      return false;
    }
  };


  /* =========================
     EXISTENCIA DEL PEDIDO
  ========================== */

  const exists =
    () =>
      Boolean(
        get()
      );


  /* =========================
     API PÚBLICA
  ========================== */

  window.PeguuOrder =
    Object.freeze({
      get,
      set,
      update,
      remove,
      clear,
      exists,

      storageKey:
        ORDER_STORAGE_KEY,

      updatedEvent:
        ORDER_UPDATED_EVENT
    });

})();